<script>
  import { format } from 'svelte-i18n';
  import { FormGroup, Label } from '@sveltestrap/sveltestrap';

  import { Color } from '@client/components/color';

  import { colorBackground, colorPrimary, colorSecondary, colorTertiary, colorText } from '@client/stores/brand';
</script>

<header>
  <h2>{$format('label.BRAND_WIZARD_STEP_COLORS')}</h2>
  <p class="mb-4">{$format('label.BRAND_WIZARD_STEP_COLORS_DESCRIPTION')}</p>
</header>

<FormGroup>
  <Label for="brand">{$format('label.BRAND_PRIMARY_COLOR')}</Label>
  <Color id="brand" bsSize="lg" bind:value={$colorPrimary} />
</FormGroup>

<FormGroup>
  <Label for="secondary">{$format('label.BRAND_SECONDARY_COLOR')}</Label>
  <Color id="secondary" bsSize="lg" bind:value={$colorSecondary} />
</FormGroup>

<FormGroup>
  <Label for="tertiary">{$format('label.BRAND_TERTIARY_COLOR')}</Label>
  <Color id="tertiary" bsSize="lg" bind:value={$colorTertiary} />
</FormGroup>

<FormGroup>
  <Label for="background">{$format('label.BRAND_BACKGROUND_COLOR')}</Label>
  <Color id="background" bsSize="lg" bind:value={$colorBackground} />
</FormGroup>

<FormGroup>
  <Label for="text">{$format('label.BRAND_TEXT_COLOR')}</Label>
  <Color id="text" bsSize="lg" bind:value={$colorText} />
</FormGroup>
